export enum CareerAnalyticsEventType {
  JobPostsListLoaded = 'Job Posts List Loaded',
  ApplicationFormView = 'Application Form View',
  OverviewView = 'Overview View',
  ApplicationFormApplyNowClicked = 'Application Form Apply Now Clicked',
  ApplicationSuccessView = 'Application Success View',
  ApplicationErrorView = 'Application Error View',
}
